
<div class="d-flex justify-content-center align-items-center w-100  h-100 text-center" >
    <img src="assets/images/warning.png">
    <p>نعتذر لتوقف عمليه الدفع من <span> 27 يونيو 2024 </span>الي 2<span> يوليو 2024</span> نظرا لاعمال الصيانه السنويه</p>
</div>
